async function getResponse(url, options) {
    const res = await fetch(url, options);
    return res.json();
}

export { getResponse };
